// Mundo Bacano: contagem regressiva, "ver mais" das avaliações e zoom das fotos
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  // Conta até a meia-noite de Bogotá (UTC-5): todo visitante vê o mesmo horário
  function startCountdowns() {
    var timers = document.querySelectorAll('[data-mb-countdown-timer]');
    var caixas = document.querySelectorAll('[data-mb-cd]');
    if (!timers.length && !caixas.length) return;
    function tick() {
      var dia = 86400000, bog = Date.now() - 5 * 3600000;
      var s = Math.max(0, Math.floor((dia - (bog % dia)) / 1000));
      var h = pad(Math.floor(s / 3600)), m = pad(Math.floor((s % 3600) / 60)), ss = pad(s % 60);
      timers.forEach(function (t) { t.textContent = h + ':' + m + ':' + ss; });
      caixas.forEach(function (c) { var v = c.dataset.mbCd === 'h' ? h : c.dataset.mbCd === 'm' ? m : ss; if (c.textContent !== v) c.textContent = v; });
    }
    tick();
    setInterval(tick, 1000);
  }

  function initReviews(root) {
    var more = root.querySelector('[data-mb-reviews-more]');
    var perPage = parseInt(root.dataset.perPage, 10) || 6;
    if (more) {
      more.addEventListener('click', function () {
        var hidden = root.querySelectorAll('[data-mb-review].is-hidden');
        for (var i = 0; i < hidden.length && i < perPage; i++) hidden[i].classList.remove('is-hidden');
        if (hidden.length <= perPage) more.remove();
      });
    }
    // Galeria: fotos e vídeos da avaliação, com setas para passar
    var dialog = root.querySelector('[data-mb-zoom-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var palco = dialog.querySelector('[data-mb-palco]');
    var conta = dialog.querySelector('[data-mb-zoom-conta]');
    var bAnt = dialog.querySelector('[data-mb-zoom-ant]');
    var bProx = dialog.querySelector('[data-mb-zoom-prox]');
    var itens = [];
    var atual = 0;
    function mostrar(i) {
      atual = (i + itens.length) % itens.length;
      var it = itens[atual];
      palco.textContent = '';
      var el;
      if (it.t === 'v') {
        el = document.createElement('video');
        el.src = it.u;
        if (it.p) el.poster = it.p;
        el.controls = true;
        el.autoplay = true;
        el.playsInline = true;
      } else {
        el = document.createElement('img');
        el.src = it.u;
        el.alt = '';
      }
      palco.appendChild(el);
      var varios = itens.length > 1;
      bAnt.hidden = !varios;
      bProx.hidden = !varios;
      conta.textContent = varios ? (atual + 1) + ' / ' + itens.length : '';
    }
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mb-galeria]');
      if (!btn) return;
      try { itens = JSON.parse(btn.dataset.mbGaleria) || []; } catch (err) { itens = []; }
      itens = itens.filter(function (x) { return x && x.u; });
      if (!itens.length) return;
      mostrar(0);
      dialog.showModal();
    });
    bAnt.addEventListener('click', function () { mostrar(atual - 1); });
    bProx.addEventListener('click', function () { mostrar(atual + 1); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') mostrar(atual - 1);
      if (e.key === 'ArrowRight') mostrar(atual + 1);
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.closest('[data-mb-zoom-close]')) dialog.close();
    });
    dialog.addEventListener('close', function () { palco.textContent = ''; });
  }

  function init() {
    startCountdowns();
    document.querySelectorAll('[data-mb-reviews]').forEach(initReviews);
  }

  // Links internos (ex.: estrelas → avaliações) rolam sem pôr #âncora no endereço,
  // senão recarregar ou copiar o link abre a página já lá embaixo
  // Proteção contra cópia (Configurações do tema → Mundo Bacano). Dificulta, não impede: quem sabe usar as ferramentas do navegador ainda consegue.
  if (document.body.classList.contains('mb-protect')) {
    var editavel = function (el) { return el && el.closest && el.closest('input, textarea, select, [contenteditable="true"]'); };
    document.addEventListener('contextmenu', function (e) { if (!editavel(e.target)) e.preventDefault(); });
    document.addEventListener('dragstart', function (e) { if (e.target.tagName === 'IMG') e.preventDefault(); });
    document.addEventListener('copy', function (e) { if (!editavel(e.target)) e.preventDefault(); });
    document.addEventListener('keydown', function (e) {
      var k = (e.key || '').toLowerCase(), ctrl = e.ctrlKey || e.metaKey;
      if (editavel(e.target) && ctrl && (k === 'c' || k === 'a' || k === 'x' || k === 'v')) return;
      if (e.key === 'F12' || (ctrl && ['c', 'u', 's', 'p'].indexOf(k) > -1) || (ctrl && e.shiftKey && ['i', 'j', 'c'].indexOf(k) > -1)) e.preventDefault();
    });
  }

  // Botões "Pedir ahora" das seções: abrem o formulário do CODrop (padrão) ou, se só houver ele, o do Releasit
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mb-buy]');
    if (!b) return;
    var cs = document.querySelectorAll('[data-rcod-open]');
    for (var j = 0; j < cs.length; j++) {
      if (cs[j].offsetHeight > 0) { cs[j].click(); return; }
    }
    var bs = document.querySelectorAll('#rsi_buy_now_button');
    for (var i = 0; i < bs.length; i++) {
      if (bs[i].offsetHeight > 0 && !bs[i].closest('#floatingBuyNowButton, #CartDrawer, cart-drawer')) { bs[i].click(); return; }
    }
    var f = document.querySelector('.product-form__submit, product-info');
    if (f) f.scrollIntoView({ block: 'center' });
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-mb-scroll-to]');
    if (!link) return;
    var alvo = document.getElementById(link.getAttribute('data-mb-scroll-to'));
    if (!alvo) return;
    e.preventDefault();
    alvo.scrollIntoView({ block: 'start' });
  });

  // Carrossel das avaliações: setas laterais e troca automática; só age quando o layout atual é carrossel
  function initCarousel(root) {
    var track = root.querySelector('[data-mb-track]');
    var prev = root.querySelector('[data-mb-prev]');
    var next = root.querySelector('[data-mb-next]');
    if (!track || !prev || !next) return;
    var segundos = parseInt(root.dataset.autoplay, 10) || 0;
    var pausado = false;

    function ativo() { return getComputedStyle(track).gridAutoFlow.indexOf('column') !== -1; }
    function passo() {
      var card = track.querySelector('.mb-review');
      if (!card) return track.clientWidth;
      return card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
    }
    function noFim() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
    // Infinito: depois da última volta para a primeira, e antes da primeira vai para a última
    function avancar() {
      if (noFim()) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: passo(), behavior: 'smooth' });
    }
    function voltar() {
      if (track.scrollLeft <= 4) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      else track.scrollBy({ left: -passo(), behavior: 'smooth' });
    }

    prev.addEventListener('click', voltar);
    next.addEventListener('click', avancar);
    ['mouseenter', 'touchstart', 'focusin'].forEach(function (ev) {
      root.addEventListener(ev, function () { pausado = true; }, { passive: true });
    });
    ['mouseleave', 'touchend', 'focusout'].forEach(function (ev) {
      root.addEventListener(ev, function () { setTimeout(function () { pausado = false; }, 3000); }, { passive: true });
    });

    if (segundos > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setInterval(function () {
        if (!pausado && ativo() && !document.hidden) avancar();
      }, segundos * 1000);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.querySelectorAll('[data-mb-carousel]').forEach(initCarousel);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-mb-reviews]').forEach(initReviews);
    e.target.querySelectorAll('[data-mb-carousel]').forEach(initCarousel);
  });
})();


/* ===== Efeitos premium: preço animado, blocos que surgem, brilho ===== */
(function () {
  var reduz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fmt = function (v) { return '$' + Math.round(v).toLocaleString('es-CO').replace(/,/g, '.'); };
  var ease = function (x) { return x === 1 ? 1 : 1 - Math.pow(2, -10 * x); };

  function animarPreco(box, de, para, numEl, extras) {
    if (box.dataset.mbDone) return; box.dataset.mbDone = '1';
    if (reduz || !(de > para)) { box.classList.add('mb-pa-fim'); return; }
    box.classList.add('mb-pa-rodando');
    var dur = 1500, t0 = 0, fim = false;
    numEl.textContent = fmt(de);
    function acabar() { if (fim) return; fim = true; numEl.textContent = fmt(para); box.classList.remove('mb-pa-rodando'); box.classList.add('mb-pa-fim'); }
    function quadro() {
      if (fim) return;
      var p = Math.min(1, (Date.now() - t0) / dur), v = de - (de - para) * ease(p);
      numEl.textContent = fmt(Math.round(v / 100) * 100);
      if (p < 1) setTimeout(quadro, 30); else acabar();
    }
    setTimeout(function () { t0 = Date.now(); quadro(); }, 250);
    setTimeout(acabar, dur + 1200); // garantia: nunca fica parado no preço antigo
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (!e.isIntersecting) return; io.unobserve(e.target); e.target.__mbGo && e.target.__mbGo(); });
  }, { threshold: 0.45 }) : null;

  function prepararBloco(box) {
    var de = +box.dataset.from, para = +box.dataset.to;
    var num = box.querySelector('strong'); if (!num || !(de > para)) return;
    box.classList.add('mb-pa');
    box.__mbGo = function () { animarPreco(box, de, para, num); };
    if (io) io.observe(box); else box.__mbGo();
  }
  document.querySelectorAll('[data-mb-price-anim]').forEach(prepararBloco);

  // Preço do topo (bloco padrão do tema)
  var topo = document.querySelector('.product__info-container .price--on-sale .price__sale');
  if (topo) {
    var reg = topo.querySelector('s.price-item--regular'), sale = topo.querySelector('.price-item--sale');
    var n = function (el) { return el ? +el.textContent.replace(/[^\d]/g, '') : 0; };
    var de = n(reg), para = n(sale);
    if (sale && de > para) {
      topo.classList.add('mb-pa', 'mb-pa--topo');
      var alvo = topo.closest('.price') || topo;
      alvo.__mbGo = function () { animarPreco(topo, de, para, sale); };
      if (io) io.observe(alvo); else alvo.__mbGo();
      // Garantia: se já está na tela ao carregar, roda mesmo sem o observador disparar
      setTimeout(function () { var r = alvo.getBoundingClientRect(); if (r.top < innerHeight && r.bottom > 0) alvo.__mbGo(); }, 900);
    }
  }

  // Blocos da página de vendas surgem ao rolar
  if (!reduz && io) {
    var rv = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('mb-rv--on'); rv.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.mb-landing__inner > *, .mb-l-proof__card, .mb-l-steps__list > li').forEach(function (el, i) {
      el.classList.add('mb-rv'); rv.observe(el);
    });
    document.querySelectorAll('.mb-l-proof__grid, .mb-l-steps__list').forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (c, i) { c.style.transitionDelay = (i * 0.12) + 's'; });
    });
  }
})();


/* ===== Galeria: barrinhas + "Desliza para ver más" entre a foto grande e as miniaturas ===== */
(function () {
  var viewer = document.querySelector('media-gallery slider-component[id^="GalleryViewer"]');
  if (!viewer) return;
  var lista = viewer.querySelector('.product__media-list');
  var itens = lista ? lista.querySelectorAll('.product__media-item') : [];
  if (itens.length < 2) return;
  var bar = document.createElement('div');
  bar.className = 'mb-swipe';
  var html = '<div class="mb-swipe__bars">';
  for (var i = 0; i < itens.length; i++) html += '<span' + (i === 0 ? ' class="on"' : '') + '></span>';
  // Setinhas apontando para a esquerda, acendendo em sequência: imitam o gesto do dedo
  var chev = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
  html += '</div><div class="mb-swipe__hint"><span class="mb-swipe__chev" aria-hidden="true">' + chev + chev + chev + '</span><span>Desliza para ver más</span></div>';
  bar.innerHTML = html;
  viewer.insertAdjacentElement('afterend', bar);
  var barras = bar.querySelectorAll('.mb-swipe__bars span');
  var atual = 0;
  function atualiza() {
    var w = lista.clientWidth || 1, idx = Math.round(lista.scrollLeft / w);
    if (idx === atual) return; atual = idx;
    barras.forEach(function (b, k) { b.classList.toggle('on', k === idx); b.classList.toggle('vista', k < idx); });
    if (idx > 0) bar.classList.add('usou');
  }
  lista.addEventListener('scroll', function () { requestAnimationFrame(atualiza); }, { passive: true });
  // Dica de movimento: a primeira foto "espia" para o lado uma vez, só no celular
  var reduz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduz && window.matchMedia('(max-width: 749px)').matches && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return; io.disconnect();
      setTimeout(function () {
        if (lista.scrollLeft > 5) return;
        lista.style.scrollSnapType = 'none';
        lista.scrollTo({ left: 70, behavior: 'smooth' });
        setTimeout(function () { lista.scrollTo({ left: 0, behavior: 'smooth' }); setTimeout(function () { lista.style.scrollSnapType = ''; }, 500); }, 550);
      }, 1400);
    }, { threshold: 0.6 });
    io.observe(lista);
  }
})();


/* ===== Botão fixo da Releasit: só depois do botão principal (e some perto da oferta final) ===== */
(function () {
  if (!document.querySelector('.product__info-container')) return;
  // O botão principal é o da Releasit visível fora da barra fixa (há ganchos vazios de altura zero)
  function botaoPrincipal() {
    var c = document.querySelector('.product__info-container [data-rcod-open]');
    if (c && c.offsetHeight > 0) return c;
    var bs = document.querySelectorAll('#rsi_buy_now_button');
    for (var i = 0; i < bs.length; i++) {
      if (!bs[i].closest('#floatingBuyNowButton') && bs[i].offsetHeight > 0) return bs[i];
    }
    return null;
  }
  var agendado = false;
  function confere() {
    agendado = false;
    var b = botaoPrincipal();
    var passou = b ? b.getBoundingClientRect().bottom < 0 : false;
    var oferta = document.querySelector('.mb-l-offer__btn'), perto = false;
    if (oferta) { var r = oferta.getBoundingClientRect(); perto = r.top < innerHeight && r.bottom > 0; }
    document.body.classList.toggle('mb-fixo-ok', passou && !perto);
  }
  window.addEventListener('scroll', function () { if (!agendado) { agendado = true; setTimeout(confere, 60); } }, { passive: true });
  window.addEventListener('resize', confere);
  confere();
})();


/* ===== Barra de avisos: aparece fixa só depois que o cliente começa a rolar ===== */
(function () {
  if (!document.querySelector('.mb-ticker--ao-rolar')) return;
  var ag = false;
  function confere() { ag = false; document.body.classList.toggle('mb-rolou', window.scrollY > 120); }
  window.addEventListener('scroll', function () { if (!ag) { ag = true; setTimeout(confere, 50); } }, { passive: true });
  confere();
})();


/* ===== Antes e depois: arrastar a bolinha ===== */
(function () {
  document.querySelectorAll('[data-mb-ba]').forEach(function (box) {
    var r = box.querySelector('.mb-l-ba__range');
    if (!r) return;
    function set() { box.style.setProperty('--pos', r.value + '%'); }
    r.addEventListener('input', function () { set(); box.classList.add('usou'); });
    set();
  });
})();
